(function () {
  function initMetaPageNav() {
    document.querySelectorAll('[data-meta-page-nav]').forEach(function (nav) {
      var list = nav.querySelector('[data-meta-page-nav-list]');
      if (!list) return;

      list.innerHTML = '';

      var anchors = document.querySelectorAll('[data-meta-nav][id]');
      if (!anchors.length) {
        nav.hidden = true;
        return;
      }

      anchors.forEach(function (anchor) {
        var label = anchor.getAttribute('data-meta-nav-label');
        var targetId = anchor.id;
        if (!label || !targetId) return;

        var link = document.createElement('a');
        link.className = 'product-meta-nav__pill';
        link.href = '#' + targetId;
        link.textContent = label;
        list.appendChild(link);
      });

      if (!list.children.length) {
        nav.hidden = true;
        return;
      }

      nav.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMetaPageNav);
  } else {
    initMetaPageNav();
  }
})();
